import React, { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
import { DemandCarliChat } from './DemandCarliChat';
import { DemandPlatformConnections } from './DemandPlatformConnections';
type DemandScope = {
  label: string;
  detail: string;
};
function getDemandScope(selectedOwner: string): DemandScope {
  if (selectedOwner === 'Eddy') return {
    label: 'Eddy',
    detail: 'Eddy inventory and approved channel context'
  };
  if (selectedOwner === '1 People') return {
    label: '1 People',
    detail: '1 People inventory and approved channel context'
  };
  if (selectedOwner) return {
    label: selectedOwner,
    detail: 'Selected brand inventory and approved channel context'
  };
  return {
    label: 'All available brands',
    detail: 'Live inventory, campaign, and channel context across approved brands'
  };
}
export function DemandDashboard({
  selectedOwner
}: {
  selectedOwner: string;
}) {
  const scope = getDemandScope(selectedOwner);
  const [workspaceOpen, setWorkspaceOpen] = useState(true);
  return <div className="mx-auto max-w-[1500px] px-5 py-6 sm:px-8 lg:py-8" aria-labelledby="demand-heading" data-id="element-634" data-mp="5b506xf9698e">
      <h1 id="demand-heading" className="sr-only" data-id="element-635" data-mp="bk1mo3zw2w7">Carli for Demand</h1>
      <section aria-label="Carli collaboration workspace" data-id="element-636" data-mp="3sfkxzjirumjb">
        <button type="button" onClick={() => setWorkspaceOpen(open => !open)} aria-expanded={workspaceOpen} className={`flex w-full items-center justify-between rounded-2xl px-3 py-2.5 text-left ${workspaceOpen ? 'mb-3' : 'border border-ink/10 bg-paper shadow-sm'}`} data-id="element-637" data-mp="3se1gjpldq5fy"><span className="flex items-center gap-2 text-sm font-semibold" data-id="element-638" data-mp="3dqgbvr8uvy5x"><span aria-hidden="true" className="h-4 w-4 shrink-0 bg-[#BB5E40]" style={{
            WebkitMaskImage: 'url(https://cdn.magicpatterns.com/uploads/1TE2x8VkDnCcShd3sjGJpW/carli_icon.svg)',
            maskImage: 'url(https://cdn.magicpatterns.com/uploads/1TE2x8VkDnCcShd3sjGJpW/carli_icon.svg)',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
            WebkitMaskSize: 'contain',
            maskSize: 'contain'
          }} data-id="element-639" data-mp="3dovfdw2ze55f" />Carli workspace<span className="hidden text-xs font-normal text-ink/50 sm:inline" data-id="element-640" data-mp="2l36ucvgijt73">· Conversations, campaign rooms, and team channels</span></span>{workspaceOpen ? <ChevronDownIcon className="h-4 w-4 text-ink/45" data-id="element-641" data-mp="2q0ylvod8xdar" /> : <ChevronRightIcon className="h-4 w-4 text-ink/45" data-id="element-642" data-mp="2b73szrthjyl7" />}</button>
        {workspaceOpen && <DemandCarliChat scopeLabel={scope.label} scopeDetail={scope.detail} data-id="element-643" data-mp="2g4c3d68e6ybw" />}
      </section>
      <DemandPlatformConnections data-id="element-644" data-mp="33ug51820so09" />
    </div>;
}